// فترات فلتر تاريخ التذاكر (حسب تاريخ الإنشاء). الافتراضي: هذا الشهر.
export const DEFAULT_TICKET_PERIOD = 'month';

export const TICKET_PERIODS = [
    { value: 'month', ar: 'هذا الشهر', en: 'This month' },
    { value: '3m', ar: 'آخر 3 شهور', en: 'Last 3 months' },
    { value: '9m', ar: 'آخر 9 شهور', en: 'Last 9 months' },
    { value: 'year', ar: 'السنة الحالية', en: 'This year' },
    { value: 'all', ar: 'كل الفترات', en: 'All time' },
    { value: 'custom', ar: 'فترة مخصصة', en: 'Custom range' },
];

const isValidPeriod = (value) => TICKET_PERIODS.some((item) => item.value === value);

export const normalizeTicketPeriod = (value) => {
    const raw = String(value || '').trim().toLowerCase();
    return isValidPeriod(raw) ? raw : DEFAULT_TICKET_PERIOD;
};

const pad2 = (value) => String(value).padStart(2, '0');
export const toDateInputValue = (date) =>
    date && !Number.isNaN(date.getTime())
        ? `${date.getFullYear()}-${pad2(date.getMonth() + 1)}-${pad2(date.getDate())}`
        : '';

const parseDateInput = (value) => {
    const match = /^(\d{4})-(\d{2})-(\d{2})$/.exec(String(value || '').trim());
    if (!match) return null;
    const date = new Date(Number(match[1]), Number(match[2]) - 1, Number(match[3]));
    return Number.isNaN(date.getTime()) ? null : date;
};

// بيرجع { from, to } كـ Date بتوقيت المتصفح؛ to حصري (بداية اليوم اللي بعد آخر يوم).
export const resolveTicketDateRange = (period, fromValue, toValue, now = new Date()) => {
    const today = new Date(now.getFullYear(), now.getMonth(), now.getDate());
    switch (normalizeTicketPeriod(period)) {
        case 'month':
            return { from: new Date(now.getFullYear(), now.getMonth(), 1), to: new Date(now.getFullYear(), now.getMonth() + 1, 1) };
        case '3m':
            return { from: new Date(today.getFullYear(), today.getMonth() - 3, today.getDate()), to: null };
        case '9m':
            return { from: new Date(today.getFullYear(), today.getMonth() - 9, today.getDate()), to: null };
        case 'year':
            return { from: new Date(now.getFullYear(), 0, 1), to: new Date(now.getFullYear() + 1, 0, 1) };
        case 'custom': {
            const from = parseDateInput(fromValue);
            const toDay = parseDateInput(toValue);
            const to = toDay ? new Date(toDay.getFullYear(), toDay.getMonth(), toDay.getDate() + 1) : null;
            return { from, to };
        }
        case 'all':
        default:
            return { from: null, to: null };
    }
};

// يضيف dateFrom/dateTo (ISO) لبارامترات الـ API حسب الفترة المختارة في رابط الصفحة.
export const applyTicketDateParams = (apiParams, searchParams) => {
    const { from, to } = resolveTicketDateRange(
        searchParams.get('period'),
        searchParams.get('from'),
        searchParams.get('to')
    );
    if (from) apiParams.set('dateFrom', from.toISOString());
    if (to) apiParams.set('dateTo', to.toISOString());
    return apiParams;
};

export const formatTicketPeriodRange = (period, fromValue, toValue, lang = 'ar') => {
    const { from, to } = resolveTicketDateRange(period, fromValue, toValue);
    if (!from && !to) return '';
    const fmt = (date) => date.toLocaleDateString(lang === 'ar' ? 'ar-EG' : 'en-GB', { day: 'numeric', month: 'short', year: 'numeric' });
    const lastDay = to ? new Date(to.getFullYear(), to.getMonth(), to.getDate() - 1) : new Date();
    if (!from) return `${lang === 'ar' ? 'حتى' : 'Until'} ${fmt(lastDay)}`;
    return `${fmt(from)} – ${fmt(lastDay)}`;
};
